import clsx from 'clsx';
import { statusBadge, statusTone } from '../lib/incident-helpers';
import type { IncidentStatus } from '../lib/incidents-api';

interface Props {
  status: IncidentStatus;
  className?: string;
}

export function IncidentStatusBadge({ status, className }: Props) {
  const tone = statusTone(status);
  return (
    <span
      className={clsx(
        'inline-block rounded px-1.5 py-0.5 text-[11px] font-bold uppercase tracking-wider',
        tone === 'ok' && 'bg-ok-bg text-ok-fg',
        tone === 'warn' && 'bg-warn-bg text-warn-fg',
        tone === 'down' && 'bg-down-bg text-down-fg',
        tone === 'info' && 'bg-info-bg text-info-fg',
        className,
      )}
    >
      {statusBadge(status)}
    </span>
  );
}
